import Radio from './Radio'
import RadioGroup from './RadioGroup.js'
Radio.RadioGroup = RadioGroup
export default Radio
